import { AppTextField } from '../../components/AppTextField';
import EditFormComponent from '../common/EditFormComponent';
import { ExerciseTypesType } from '../../types/exercisetypes.type';
import { ExerciseTypesServices } from '../../services/exercisetypes.service';
import { CRUDType } from '../../types/crud.type';

export function EditExerciseType({ mode }: CRUDType) {
    return (
        <EditFormComponent<ExerciseTypesType>
            title="Exercise Type"
            mode={mode}
            backPath="/exercisetypes"
            service={{
                getById: ExerciseTypesServices.getById,
                add: ExerciseTypesServices.add,
                update: ExerciseTypesServices.update,
            }}
            formFields={[
                { name: 'name', component: AppTextField, props: { label: 'Name', rules: { required: 'Name is required' } } },
                { name: 'description', component: AppTextField, props: { label: 'Description' } },
            ]}
        />
    );
}
